export const NAME_MAX_LENGTH = 24;

/** Shorten long names in tables; show the full name in a hover title. */
export const truncateName = (name: string, max = NAME_MAX_LENGTH) =>
  name.length > max ? `${name.slice(0, max - 1).trimEnd()}…` : name;
